export default __webpack_public_path__ + "static/media/twitter.bc7ee516.svg";